import React from "react"

const FLOSSIE_FRANCHISE_THEME = {
  wwwBgImageSize: "cover",
  wwwBgImageBlendMode: "multiply",

} // default is flossie, in global styled, others override.

export default FLOSSIE_FRANCHISE_THEME
